<!-- my-dialog.component.html -->
<h2 mat-dialog-title>{{ dialogEnum.SIGNUP_CANCEL_DIALOG_HEADER }}</h2>
<mat-dialog-content>
  <!-- Your dialog content goes here -->
  <p>
    {{ dialogEnum.SIGNUP_CANCEL_DIALOG_CONTENT_1 }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-dialog-close class="btn">Cancel</button>
  <button [mat-dialog-close]="true" class="btn btn-primary">Yes, Cancel</button>
</mat-dialog-actions>
